
/**
 * Coordinates that define the position of a view inside the worksheet grid. It's an array of
 * exactly 4 integers between (and including) 0 and smaller (excluding) the GRID_SIZE (currently set
 * to 48, may change).
 * Structure: [ rowStart, colStart, rowEnd, colEnd ]
 * You can assert the structure by using `validateGridArea()`:
 *
 * @example
 * assert(validateGridArea(layout), 'Grid area must be an array of coordinates, defining a rect');
 *
 * You can use `convertWorksheetGridToCssGridArea()` and `convertCssGridAreaToWorksheetGrid()` to
 * convert between the worksheet grid format and the CSS grid format.
 */
export type GridAreaDto = [ rowStart: number, colStart: number, rowEnd: number, colEnd: number ];

export const rowStart = (gridArea: GridAreaDto) => gridArea[0];
export const colStart = (gridArea: GridAreaDto) => gridArea[1];
export const rowEnd = (gridArea: GridAreaDto) => gridArea[2];
export const colEnd = (gridArea: GridAreaDto) => gridArea[3];
